import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "./Testimoni.css";
import { Autoplay, Navigation } from "swiper/modules";

const Testimoni = () => {
  return (
    <React.Fragment>
      <div id="testimoni" className="container-testimoni">
        <h1 className="title-testimoni">
          Mereka Sudah Membuktikan <br /> Sekarang Giliranmu!
        </h1>
        <div className="box-testimoni">
          <Swiper
            slidesPerView={4} // default: 4 slides per view
            spaceBetween={10} // ruang antar slide
            navigation={false}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            loop={true}
            modules={[Navigation, Autoplay]}
            breakpoints={{
              // ketika lebar layar lebih besar dari 1200px
              1200: {
                slidesPerView: 4, // 4 slides pada layar besar
                spaceBetween: 20, // ruang antar slide
              },
              // ketika lebar layar lebih besar dari 768px
              768: {
                slidesPerView: 3, // 3 slides pada layar sedang
                spaceBetween: 15, // ruang antar slide
              },
              // ketika lebar layar lebih besar dari 480px
              480: {
                slidesPerView: 2, // 2 slides pada layar kecil
                spaceBetween: 10, // ruang antar slide
              },
              // untuk layar lebih kecil dari 480px
              0: {
                slidesPerView: 1, // 1 slide pada layar kecil banget
                spaceBetween: 10, // ruang antar slide
              },
            }}
            className="mySwiper"
          >
            <SwiperSlide className="bgcard-testimoni">
              <img
                src="https://tarunapersada.com/storage/images/landing/testimonial-ananda-caisar.webp"
                alt="Bimbel Bintara Polri"
                className="img-header-testimoni"
              />
              <img
                src="https://static.vecteezy.com/system/resources/previews/003/355/389/original/five-5-star-rank-sign-illustration-free-vector.jpg"
                alt="Bimbel Bintara Polri"
                className="star-five"
              />
              <h3 className="title-card-testimoni">Ananda Caisar</h3>
              <p className="desk-desk-card-testimoni">
                Selamat Pagi Kak, alhamdulillah 2 kali pertemuan saya cocok,
                tutornya datang tepat waktu dan penyampaian materi mudah
                dipahami.
              </p>
            </SwiperSlide>
            <SwiperSlide className="bgcard-testimoni">
              <img
                src="https://tarunapersada.com/storage/images/landing/testimonial-zhafif-agis-risqullah.webp"
                alt="Bimbel Bintara Polri"
                className="img-header-testimoni"
              />
              <img
                src="https://static.vecteezy.com/system/resources/previews/003/355/389/original/five-5-star-rank-sign-illustration-free-vector.jpg"
                alt="Bimbel Bintara Polri"
                className="star-five"
              />
              <h3 className="title-card-testimoni">Zhafif Agis Risqullah</h3>
              <p className="desk-desk-card-testimoni">
                Saya senang latihan fisik di Edumatrix, karena pelatih dan teman
                - teman yang menyenangkan.
              </p>
            </SwiperSlide>
            <SwiperSlide className="bgcard-testimoni">
              <img
                src="https://tarunapersada.com/storage/images/landing/testimonial-rizky-alfiansyah-ramadhan.webp"
                alt="Bimbel Bintara Polri"
                className="img-header-testimoni"
              />
              <img
                src="https://static.vecteezy.com/system/resources/previews/003/355/389/original/five-5-star-rank-sign-illustration-free-vector.jpg"
                alt="Bimbel Bintara Polri"
                className="star-five"
              />
              <h3 className="title-card-testimoni">
                Rizky Alfiansyah Ramadhan
              </h3>
              <p className="desk-desk-card-testimoni">
                Saya senang bisa belajar di Edumatrix, karena disini saya bisa
                lebih mudah memahami materi - materi Psikotes
              </p>
            </SwiperSlide>
            <SwiperSlide className="bgcard-testimoni">
              <img
                src="https://tarunapersada.com/storage/images/landing/testimonial-muhammad-asyam.webp"
                alt="Bimbel Bintara Polri"
                className="img-header-testimoni"
              />
              <img
                src="https://static.vecteezy.com/system/resources/previews/003/355/389/original/five-5-star-rank-sign-illustration-free-vector.jpg"
                alt="Bimbel Bintara Polri"
                className="star-five"
              />
              <h3 className="title-card-testimoni">Muhammad Asyam</h3>
              <p className="desk-desk-card-testimoni">
                Sejauh ini saya belajar di Edumatrix tidak ada kendala, tutor
                yang membimbing juga cocok - cocok aja.
              </p>
            </SwiperSlide>
            <SwiperSlide className="bgcard-testimoni">
              <img
                src="https://tarunapersada.com/storage/images/landing/testimonial-iksan-wisnu-wardana.webp"
                alt="Bimbel Bintara Polri"
                className="img-header-testimoni"
              />
              <img
                src="https://static.vecteezy.com/system/resources/previews/003/355/389/original/five-5-star-rank-sign-illustration-free-vector.jpg"
                alt="Bimbel Bintara Polri"
                className="star-five"
              />
              <h3 className="title-card-testimoni">Iksan Wisnu Wardana</h3>
              <p className="desk-desk-card-testimoni">
                Tahun lalu saya gagal seleksi Bintara polri, kali ini
                memutuskan bergabung bersama Edumatrix. Alhamdulillah banyak
                peningkatan.
              </p>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Testimoni;
